import styled from 'styled-components';
import Background from '../../assets/testimonials/bg-testimonios.jpg';
import TestimonialBoxBg from '../../assets/testimonials/acuarela-testimonios.png';
import ComillasOpen from '../../assets/testimonials/comillas_open.svg';
import ComillasClose from '../../assets/testimonials/comillas_close.svg';


const TestimonialsStyle = styled.section`
  display: flex;
  width: 100%;
  flex: 0 0 50%;

  @media(max-width: 800px) {
    display: none;
  }
`;

const ColumnA = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 550px;
  align-items: center;
  justify-content: center;
  background: url(${Background}) top center no-repeat;
  background-size: cover;

  &:after {
    content: '';
    position: absolute;
    height: 100px;
    width: 100%;
    bottom: 0;
    opacity: 0.64;
    background-color: #007e78;
  }

  p {
    color: #fff;
    font-size: 140px;
    line-height: 0.91;
    font-family: 'FeltThatW01-Regular';
    text-shadow: 0 12px 12px rgb(0 0 0 / 16%);
  }
`;

const ColumnB = styled.div`
  display: flex;
  width: 100%;
  height: 550px;
  flex-direction: column;
`;

const ColumnRow = styled.div`
  display: flex;
  width: 100%;
  height: 174px;
  flex-direction: row;
`;

const ItemTestimonial = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;

  &.active {
    opacity: 0.65;
    background-color: #0a3941;
    background-blend-mode: overlay;
  }

  p, h3 {
    color: #fff;
    font-size: 15px;
    font-weight: 900;
    text-shadow: -0.2px 2px 6px rgb(0 0 0 / 56%);
  }
`;

const TestimonialBox = styled.div`
  display: block;
  width: 100%;
  width: 100%;
  height: 376px;
  padding: 100px 50px;
  background: url(${TestimonialBoxBg}) -200px -150px no-repeat #007e78;

  p {
    position: relative;
    display: block;
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: -0.38px;

    &:before {
      content: url(${ComillasOpen});
      position: absolute;
      width: 46px;
      height: 29px;
      top: -40px;
    }

    &:after {
      content: url(${ComillasClose});
      position: absolute;
      width: 46px;
      height: 29px;
      bottom: -20px;
    }
  }
`;

export { TestimonialsStyle, ColumnA, ColumnB, ColumnRow, ItemTestimonial, TestimonialBox };
